import React from 'react';
import { withRouter } from '../../common/withRouter';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DataDefinitionList,
  EditableArea,
  Notification,
  Message,
  IconWithText,
  Loader,
  FormikInput
} from '../../web.common';
import { sentenceCase } from 'change-case';
import withApi from '../higherOrderComponents/withApi';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import { getApiErrorMessage } from '../../common/utils';
import { Divider, DetailsRightBar, NoLink } from './DetailsRightBar';
import {
  DisplayGuid,
  DisplayDate
} from '../items';

class ProductGroupInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      productGroupData: null
    };

    this.saveEditedProductGroup = this.saveEditedProductGroup.bind(this);
    this.isProductGroupPublic = this.isProductGroupPublic.bind(this);
  }

  async componentDidMount() {
    const { match: { params: { productGroupId } } } = this.props;
    const { api: { productGroups: { get } } } = this.props;
    const productGroupData = await get(productGroupId);
    this.setState({ productGroupData });
  }

  async onValidationError({ validateForm }) {
    const validationErrors = await validateForm();
    const fieldsWithError = Object.keys(validationErrors).map(x => sentenceCase(x)).join(', ');
    this.setState({
      apiResponse: new Message('error', `Unable to save. Check fields: ${fieldsWithError}`)
    });
  }

  saveEditedProductGroup(receivedProps) {
    this.setState({ isLoading: true }, async () => {
      const {
        props: {
          language,
          api: {
            productGroups: {
              edit
            }
          }
        },
        state: {
          productGroupData
        }
      } = this;

      let updatedProductGroupData = null;
      let apiResponse;

      try {
        updatedProductGroupData = await edit(productGroupData, receivedProps.values);
        apiResponse = new Message('success', 'ProductGroup updated successfully');
      }
      catch (error) {
        console.error(`error: ${error}`);

        this.setState({
          isLoading: false,
          apiResponse: getApiErrorMessage(error, language)
        });

        return;
      }

      this.setState({
        isLoading: false,
        productGroupData: updatedProductGroupData,
        apiResponse
      });

      receivedProps.toggleAreaEditMode();
    });
  }

  isProductGroupPublic(isPublic) {
    return (
      <IconWithText
        iconName={isPublic ? 'check' : 'times'}
        iconClasses={[`text-color-${isPublic ? 'success' : 'danger'}`]}
        text='ProductGroup is public'
      />
    );
  }

  render() {
    const { isLoading, productGroupData, apiResponse } = this.state;

    if (!productGroupData) {
      return <Loader />;
    }

    const {
      Id = 0,
      Name = '',
      Description = '',
      Summary = '',
      CreatedAt = ''
    } = productGroupData || {};

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={apiResponse} />
            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='ProductGroup page'
                documentDescription='ProductGroup page'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                ProductGroup
              </h2>
              <h5 className='main-page-subheader'>{Name}</h5>
              <br />

              {
                productGroupData ? (
                  <EditableArea
                    ariaEditorName='editor-name'
                    onSubmit={receivedProps => this.saveEditedProductGroup(receivedProps)}
                    isLoading={isLoading}
                    savingText='Updating...'
                    displayButtonLabels
                    onValidationError={formikProps => this.onValidationError(formikProps)}
                    validationSchema={Yup.object().shape({
                      Description: Yup.string()
                        .trim()
                        .min(2, 'Should be at least 2 characters long')
                        .max(256, 'Should be less than 256 characters long')
                        .required('Required'),
                      Summary: Yup.string()
                        .trim()
                        .min(2, 'Should be at least 2 characters long')
                        .max(256, 'Should be less than 256 characters long')
                        .required('Required'),
                      Name: Yup.string()
                        .trim()
                        .min(2, 'Should be at least 2 characters long')
                        .max(256, 'Should be less than 256 characters long')
                        .required('Required')
                    })}
                    initialValues={{
                      Id,
                      Name,
                      Description,
                      Summary,
                      CreatedAt
                    }}
                  >
                    {({ isEditMode }) => (
                      <React.Fragment>
                        <DataDefinitionList
                          classNames={['border-0', 'detail-page-list']}
                          listData={[{
                            Id: <DisplayGuid>{Id}</DisplayGuid>,
                            'Name*': isEditMode
                              ? <FormikInput name='Name' description='Name' placeholder required />
                              : Name,
                            'Description*': isEditMode
                              ? (
                                <FormikInput
                                  type='textarea'
                                  name='Description'
                                  description='Description'
                                  placeholder
                                />
                              )
                              : Description,
                            'Summary*': isEditMode
                              ? (
                                <FormikInput
                                  type='textarea'
                                  name='Summary'
                                  description='Summary'
                                  placeholder
                                />
                              )
                              : Summary,
                            'Created At': <DisplayDate>{CreatedAt}</DisplayDate>
                          }]}
                          hasWideDescriptions
                        />
                      </React.Fragment>
                    )}
                  </EditableArea>
                ) : ''
              }
              <DetailsRightBar>
                <Divider>Links</Divider>
                <NoLink>None</NoLink>
                <Divider>Actions</Divider>
                <NoLink>None</NoLink>
              </DetailsRightBar>
            </div>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}
const ProductGroup = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ProductGroupInternal)
));

ProductGroup.requiresLogin = true;
ProductGroup.propTypes = { isLoggedIn: PropTypes.bool };

export default ProductGroup;